import React, {useContext, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {observer, useLocalObservable} from "mobx-react";
import {API_VerificationCenter} from "../../../api/verifcationCenter";
import {useAPI} from "../../../hooks/useAPI";
import CalendarPageTemplate2 from "../../../components/Templates/CalendarPageTemplate2";
import CalendarModal from "../../../components/Calendar/CalendarModal";
import {generateRandomString} from "../../../utils/generateRandomString";
import moment from "moment";
import VerCenterCalendarModal from "../../../components/Calendar/CalendarModal/index.verificationCenter";
import {AuthContext} from "../../../context/AuthContext";
import {calendar_ApiV2_transition} from "../../SystemManager/Calendar/calendar_ApiV2_transition";

const CalendarV2 = observer(() => {
    const {calendarV2} = API_VerificationCenter
    const {orgId, orgName, medName, amoId} = useParams()
    const {APIRequest, loading} = useAPI()

    const [date, setDate] = useState(moment(new Date()).startOf('month').toISOString())
    const userId = useContext(AuthContext)?.token?.userId

    const store = useLocalObservable(() => ({
        isFromAmo: amoId,
        events: [],
        setEvents: (events) => store.events = events,
        modal: null,
        setModal: (modal) => store.modal = modal,

    }))


    const titleColorController = (event) => {
        let title = ''
        let color = ''
        let bgColor = ''


        if (event.isHolliday) {
            color = "gray"
            bgColor = "gray"
            title = "Нерабочий день"
        } else if (event.isSecured) {
            bgColor = "gray"
            color = "gray"
            title = "Занято"

        } else {
            bgColor = "white"
            color = event.color
            title = `${event?.info?.organization?.name}  ${event?.info?.med_center?.name ? `/ ${event?.info?.med_center?.name}` : ""}`
        }


        return {
            title,
            color,
            bgColor
        }
    }

    const prepareEvent = (card, event) => {
        try {
            return (
                {
                    start: new Date(card?.start_date),
                    end: new Date(card?.end_date),
                    resources: "",
                    isSecured: event?.is_secured,
                    isHolliday: event?.is_holliday,
                    ...titleColorController({...event, isSecured: event?.is_secured, isHolliday: event?.is_holliday}),
                    source: event,
                    isFromAmo: store.isFromAmo
                })
        } catch (err) {

        }
    }
    const prepareEvents = (card) => {
        const departures = card.departures

        if (departures)
            return departures.map(item => (prepareEvent(item, card)))

    }

    const getCalendar = async () => {
        if (orgId) {
            await APIRequest(calendarV2.getCalendarByOrganizationId(userId, orgId, date))
                .then(res => res.status === 200 && res.body)
                .then(body => {
                        if (body) {
                            let events = []
                            body.data.forEach(event => events.push(...prepareEvents(event)))
                            store.setEvents(events)
                        }
                    }
                )
        } else {
            await APIRequest(calendarV2.getCalendar(userId, date))
                .then(res => res.status === 200 && res.body)
                .then(body => {
                        if (body) {
                            let events = []
                            body.data.forEach(event => events.push(...prepareEvents(event)))
                            store.setEvents(events)
                        }
                    }
                )
        }

    }

    useEffect(() => {
        getCalendar()
    }, [date])

    const Modal = () => {
        return store.modal
            ? <VerCenterCalendarModal setModal={store.setModal}
                                      event={store.modal}
                                      deleteEvent={deleteEvent}
                                      onSaveAddedAmo={onSaveAddedAmo}
                                      amoId={amoId}
                                      deleteCalendarById={deleteCalendar}
                                      onSaveEditedAmo={onSaveEditedAmo}
                                      loading={loading}
            />
            : ""

    }


    const onEventClick = async (event) => {
        // const idEvent = await getEventById(event._id)
        store.setModal(event)
    }

    const onSaveEditedAmo = async (form, id) => {
        await APIRequest(calendarV2.updateItemById(userId, id), calendar_ApiV2_transition(form, userId))
        store.setModal(null)
        await getCalendar()
    }

    const onSaveAddedAmo = async (body) => {
        const b = body.departures.map(item => {
            delete item.id
            return item
        })
        body.departures = b
        await APIRequest(calendarV2.addItem(userId, amoId || ""), calendar_ApiV2_transition(body, userId))
        await store.setModal(null)
        await getCalendar()
    }

    const deleteEvent = async (calendarId, calendarItemId) => {
        await APIRequest(calendarV2.deleteCalendarItemById(userId, calendarId, calendarItemId))
    }

    const deleteCalendar = async (calendarId) => {
        await APIRequest(calendarV2.deleteCalendarById(userId, calendarId))
        store.setModal(null)
        await getCalendar()
    }

    const onCreateEvent = async (event) => {
        const start = moment(event.start)?.add(8, "hours").format()
        const end = moment(event.start)?.add(10, "hours").format()

        if (orgName) {
            const info = {
                organization: {
                    _id: orgId,
                    name: orgName
                },
                med_center: {
                    _id: "",
                    name: medName
                }
            }
            const departures = [{type: "new", start_date: start, end_date: end, id: generateRandomString(6)}]
            store.setModal({source: {info, departures}})
        } else {
            const departures = [{type: "new", start_date: start, end_date: end, id: generateRandomString(6)}]
            store.setModal({source: {departures, is_holliday: false}})
        }

    }
    const onNavigate = (date) => setDate(moment(date).startOf('month').toISOString())

    return (
        <CalendarPageTemplate2
            calendarModal={Modal}
            events={store.events}
            onEmptyClick={onCreateEvent}
            onEventClick={onEventClick}
            breadCrumbsItems={[{title: 'Календарь'}, {title: orgName ? orgName : 'Все', actual: 'true'}]}
            onNavigate={onNavigate}
        />
    )
})

export default CalendarV2;